const DEFAULT_SYMBOLS = ['', 'k', 'M']

export function abbreviateNumber(num: number, digit = 1): string {
  // handle negatives
  const sign = Math.sign(num) >= 0
  const absNum = Math.abs(num)

  // what tier? (determines SI symbol)
  const tier = (Math.log10(absNum) / 3) | 0

  // if zero, we don't need a suffix
  if (tier === 0) {
    return (!sign ? '-' : '') + absNum.toString()
  }

  // get suffix and determine scale
  const suffix = DEFAULT_SYMBOLS[tier]
  if (!suffix) {
    throw new RangeError('Не удалось определить суффикс')
  }

  const scale = 10 ** (tier * 3)

  // scale the number
  const scaled = absNum / scale

  const rounded = scaled.toFixed(digit)

  // format number and add suffix
  return (!sign ? '-' : '') + rounded + suffix
}
